export default function GapVerticalIcon() {
  return (
    <svg width='14' height='14' viewBox='0 0 14 14' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M1.5 0V3H12.5V0' stroke='#848484' />
      <path d='M12.5 14L12.5 11L1.5 11L1.5 14' stroke='#848484' />
      <path d='M3.5 7H10.5' stroke='#848484' />
    </svg>
  );
}
